import React from "react";
import { StyledHeading } from "../../shared/login_and_sign_up/styled";
import { StyledParagraphMedium } from "./set_new_password_content";

export default function PasswordLinkResentContent({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <>
      <StyledHeading data-test="password-resent-heading">{title}</StyledHeading>
      <StyledParagraphMedium>{description}</StyledParagraphMedium>
    </>
  );
}
